import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
// import { IS_SP } from '../const/config';

// 処理が重いらしいので
// HomeSlider と OtherSlider に分割し、読み込みControllerを分けます

// トップページ用スライダー
export class HomeSlider {
  constructor() {
    this.DOM = {};
    this.DOM.sliderElements = document.querySelectorAll('[data-home-slider]');
    this.DOM.mvImage = document.querySelector('[data-mv-image]');

    this.options = {};
    this.mounts = {};
    // 作成後のインスタンス
    this.splide = {}

    if (!this.DOM.sliderElements) return;

    this.setVariable();
    this.init();
  }
  setVariable(){
    // オプションを設定する
    this.options = {
      // MV管理画面
      'homeMvAdmin': {
        type : 'loop',
        rewind : true, 
        pauseOnHover: false,
        pauseOnFocus: false, 
        arrows: false,
        pagination: false,
        drag: false,
        autoplay: true,
        interval: 2000,
        speed: 1500,
        reducedMotion: {
          speed      : 1500,
          rewindSpeed: 1500,
          autoplay   : true,
        }
      }, 
      // MVのsmartwatch内の画面（homeMvAdminと連動）
      'homeMvScreen': {
        type : 'loop',
        rewind : true, 
        pauseOnHover: false,
        pauseOnFocus: false, 
        arrows: false,
        pagination: false,
        drag: false,
        speed: 900,
        reducedMotion: {
          speed: 900,
        }
      },
      // MVの管理画面右上のポップアップ（homeMvAdminと連動）
      'homeMvPopup': {
        type   : 'fade', 
        rewind : true, 
        pauseOnHover: false,
        pauseOnFocus: false, 
        arrows: false,
        pagination: false,
        drag: false,
        speed: 300,
        reducedMotion: {
          speed: 300,
        }
      },
      // MV下の素材画像の無限スクロール
      'homeEx' : {
        autoWidth: true,
        type: 'loop',
        arrows: false,
        pagination: false,
        easing: 'linear',
        autoScroll: {
          speed: 0.5,
          pauseOnHover: false,
          autoStart: true
        },
        drag: false,
        breakpoints: {
          768: { gap: '1.6rem' }
        }
      },
    };
    this.mounts = {
      'homeEx': {
        AutoScroll
      },
    };
  }

  init() {
    // 先にすべてのインスタンスを作成する
    this.DOM.sliderElements.forEach( (slider) => {

      const name = slider.getAttribute('data-home-slider');

      // インスタンスの作成と配列格納
      this.createInstance(slider, name);

    });

    // スライダー同士のsyncを定義
    this.syncSlider();

    // すべてのスライダー実行
    this.allSliderMount();

  }

  // インスタンスを作成して配列に入れる
  createInstance = (slider, name) => {
    // データ属性に紐づくoptionやmountを利用
    const option = this.options[name] ?? [ {type: 'slide'} ];
    // let mount = this.mounts[name] ?? [];
    
    // インスタンスの作成
    const splide = new Splide(slider, option);
    this.splide[name] = splide; // 格納
  }
  
  syncSlider = () => {
    
    if ( this.splide['homeMvAdmin'] ){
      this.splide['homeMvAdmin'].sync(this.splide['homeMvPopup']);
      this.splide['homeMvAdmin'].sync(this.splide['homeMvScreen']);
    }
  }
  allSliderMount(){
    Object.entries(this.splide).forEach( ( [name, slider] ) => {
      const mount = this.mounts[name] ?? [];

      if(name === 'homeMvAdmin'){

        slider.on('mounted', () => {
          this.DOM.mvImage.classList.add('is-ready');
        });
      }

      // 処理
      slider.mount(mount);
    });
  }
}

export class OtherSlider {
  constructor() {
    this.DOM = {};
    this.DOM.sliderElements = document.querySelectorAll('[data-slider]');

    this.options = {};
    this.mounts = {};
    // 作成後のインスタンス
    this.splide = {}

    if (!this.DOM.sliderElements) return;

    this.setVariable();
    this.init();
  }
  setVariable(){
    // オプションを設定する
    this.options = {
      'featuresAlert': {
        type  : 'slide',
        speed: 500,
        arrows: false,
        autoplay: true,
        interval: 3000,
        rewind: true, // 最後まで到達したら先頭に戻る
        rewindSpeed: 1000, // 最後から先頭に戻るスピード
        pagination: true,
        direction  : 'ttb',
        focus      : 'center',
        height   : '32rem',
        snap: true,
        reducedMotion: {
          speed: 500,
          rewindSpeed: 1000,
        },
        breakpoints: {
          767: { 
            perPage: 1,
            autoWidth: true,
            height: 'auto',
            direction  : 'ltr',
            trimSpace: false,
            gap: '2.5rem',
            arrows: true,
            flickMaxPages: 1, // どんなに大きくスワイプしても1枚で止める
            flickPower: 10, // フリックの感度を下げて「滑り」を抑制
            snap: true, // autoWidth使用時は必須。スライドの端に吸着させる
            waitForTransition: true // アニメーション中の連続スワイプを防止
          }
        }
      },
      'featuresDetection': {
        type  : 'slide',
        arrows: true,
        pagination: false,
        gap: '1.6rem',
        // drag: false,
        breakpoints: {
          768: { 
            autoWidth: true,
          }
        }
      },
    };
  }


  init() {

    // 先にすべてのインスタンスを作成する
    this.DOM.sliderElements.forEach( (slider) => {

      const name = slider.getAttribute('data-slider');

      // インスタンスの作成と配列格納
      this.createInstance(slider, name);

      // 特長ページのfeaturesAlert用のイベント
      if( name === 'featuresAlert' ){
        this.addFeaturesAlertEvent(name);
      } 

    });

    // スライダー同士のsyncを定義
    this.syncSlider();

    // すべてのスライダー実行
    this.allSliderMount();

  }

  // インスタンスを作成して配列に入れる
  createInstance = (slider, name) => {
    // データ属性に紐づくoptionやmountを利用
    const option = this.options[name] ?? [ {type: 'slide'} ];
    // let mount = this.mounts[name] ?? [];
    
    // インスタンスの作成
    const splide = new Splide(slider, option);
    this.splide[name] = splide; // 格納
  }
  
  syncSlider = () => {
    //
  }
  allSliderMount(){
    Object.entries(this.splide).forEach( ( [name, slider] ) => {
      const mount = this.mounts[name] ?? [];

      // 処理
      slider.mount(mount);
    });
  }

  // 機能・特徴ページのアラートスライダー専用のイベントを追加 
  addFeaturesAlertEvent = (name) => {
    
    const tabButtons = document.querySelectorAll('[data-target-slide]');
  
    // タブが押されたら製品スライドも切り替える
    tabButtons.forEach((tabButton) => {
      tabButton.addEventListener('click', () => {
        const targetSlideIndex = Number(tabButton.getAttribute('data-target-slide'));
        const currentIndex = this.splide[name].index;
        if( currentIndex !== targetSlideIndex ){
          this.splide[name].go(targetSlideIndex);
        }
      });
    });

    // スライドが切り替わったら
    // 見切れ位置の調整とタブの切り替え
    this.splide[name].on('mount move', (newIndex) => {
      // マウント時と移動開始時に、現在のアクティブ番号をCSS変数に渡す
      this.splide[name].root.style.setProperty('--active-index', newIndex);
    });

    this.splide[name].on('move', (newIndex) => {
      // 1. root要素内のすべてのスライドからクラスを削除
      const slides = this.splide[name].root.querySelectorAll('.splide__slide');
      
      slides.forEach((slide) => {
        slide.classList.remove('is-animating');
        slide.classList.remove('is-prevAnimating');
      });

      // 2. 次にアクティブになるスライドだけに付与
      // getAt(index) は最新版でも Slides コンポーネント内で有効です
      const nextSlide = this.splide[name].Components.Slides.getAt(newIndex);
      if (nextSlide) {
        nextSlide.slide.classList.add('is-animating');
      }

      // 3. タブやタブコンテンツを変更する
      const nextCurrentTab = document.querySelector(`[data-target-slide="${newIndex}"]`);
      nextCurrentTab.click();
      
    });

    // プログレスバー
    // 1. 各ドットにSVGプログレスバーを注入
    this.splide[name].on('pagination:mounted', (data) => {
      data.items.forEach((item) => {
        item.button.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 18 18">
            <circle class="prog-bg" cx="9" cy="9" r="8" fill="none" />
            <circle class="prog-bar" cx="9" cy="9" r="8" fill="none" />
          </svg>
        `;
      });
    });

    // 2. オートプレイの進捗を監視してCSS変数を更新
    this.splide[name].on('autoplay:playing', (rate) => {
      // rate は 0 から 1 の値で渡される
      const activeDot = this.splide[name].root.querySelector('.splide__pagination__page.is-active');
      if (activeDot) {
        activeDot.style.setProperty('--progress', rate);
      }
    });

    // 3. スライドが切り替わった瞬間に他のドットの進捗をリセット
    this.splide[name].on('move', () => {
      const dots = this.splide[name].root.querySelectorAll('.splide__pagination__page');
      dots.forEach((dot) => dot.style.setProperty('--progress', 0));
    });
    // ページネーションが操作されたらオートプレイを再開
    this.splide[name].on('pagination:updated', () => {
      const Autoplay = this.splide[name].Components.Autoplay;
      if (Autoplay.isPaused()) {
        Autoplay.play();
      }
    });

  }
}
